/** @format */
import Header from "./Header/Header";
import { Box, Container } from "@mui/material";
import {  Outlet } from "react-router-dom";
import Navigation from "./Navigation/Navigation";

export default function MainLayout() {

  // Render different layouts based on the URL


  // Default layout
  return (
    <Container display="flex">
      <Box display="flex" flexDirection="column" flexGrow={1} overflow="auto">
        <Box position="sticky" top="0" zIndex={99} sx={{ padding: "0 2rem" }}>
          <Header />
        </Box>

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            py: 8,
            overflow: "auto",
          }}
        >
          <Outlet />
        </Box>

        <Navigation />
      </Box>
    </Container>
  );
}
